export const style = {
  container: {
    color: "var(--gray-800)",
    fontSize: "1.6rem",
    fontWeight: "500",
  },
  buttonText: {
    color: "var(--orange-500)",
    fontSize: "1.4rem",
    fontWeight: "500",
  },
  buttonContainer: {
    padding: { xs: "1.2rem 1.6rem 0rem 1.6rem", md: "1.6rem" },
    backgroundColor: "var(--neutral-100)",
  },
  searchResults: {
    color: "var(--gray-600)",
    fontSize: "1.4rem",
    fontWeight: "400",
  },
  cityName: {
    color: "var(--gray-800)",
    fontSize: "1.2rem",
    fontWeight: "500",
  },
  stateName: {
    color: "var(--gray-500)",
    fontSize: "1.2rem",
    fontWeight: "400",
  },
  searchInputContainer: {
    marginRight: "1rem",
    "& input": {
      padding: "1.2rem",
      width: "100%",
      outline: "none",
      border: "none",
      borderRadius: "2rem",
      background: "var(--neutral-100)",
    },
  },
  searchIcon: {
    marginLeft: "-4rem",
  },
};
